import icon from '@plone/volto/icons/grid.svg'
//import BlockEdit from './Block/Edit';
//import BlockView from './Block/View';
import BlockEdit from './Edit';
import BlockView from './View';
export default function applyConfig(config) {
    config.blocks.blocksConfig.info_grid = {
        id: 'info_grid',
        title: 'Info Grid',
        edit: BlockEdit,
        view: BlockView,
        icon: icon,
        group: 'text',
        restricted: false,
        mostUsed: false,
        sidebarTab: 1,
    };
    return config;
};
